// This is the import section of an Angular component file. It imports various modules, services, and components that are used in the component.
// Angular core modules
import { Component, HostListener, OnChanges, OnInit, SimpleChanges, ViewContainerRef, OnDestroy } from '@angular/core';
// Application specific services
import { AgGridConfigurationService } from '@app/shared/services/ag-grid-configuration.service';
import { ConstantsService } from '@app/common/constants.service';
import { AddViewReleaseListService } from '@app/shared/services/add-view-release-list.service';
import { LoaderService } from '@app/shared/services/loader.service';
import { MenuContextualService } from '@app/shared/services/menu-contextual.service';
import { UserAuthService } from '@app/shared/services/user-auth.service';
// ag-Grid modules and types
import { ColDef, IColumnToolPanel, SideBarDef, GridOptions, RowModelType } from 'ag-grid-community';

// Angular router
import { Router } from '@angular/router';
// PrimeNG API
import { TableLazyLoadEvent } from 'primeng/table';
// Application specific model and component
import { AddViewRelease } from '@app/shared/model/addViewRelease';
import { ReleaseProgressComponent } from '@app/shared/shared-components/release-progress/release-progress.component';
import { AlertService } from '@app/shared/services/alert.service';
import { ToastrService } from 'ngx-toastr';
import { AgLinkRendererComponent } from '../ag-link-renderer/ag-link-renderer.component';
import { AgGridModule } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PageHeaderComponent } from '@app/shared/page-header/page-header.component';
import { MatIconModule } from '@angular/material/icon';
import { ReleaseMgmtService } from '@app/shared/services/releaseMgmtService';

@Component({
    standalone: true,
    selector: 'app-add-view-release-list',
    templateUrl: './add-view-release-list.component.html',
    styleUrls: ['./add-view-release-list.component.scss'],
    imports: [AgGridModule, CommonModule, MatTooltipModule, PageHeaderComponent, MatIconModule]
})
export class AddViewReleaseListComponent implements OnInit, OnDestroy {
  // Set the initial value for the fsValue variable
  fsValue = 'fs-12';
// Add this property to your component
hotfixDisabledStatus: { [key: string]: boolean } = {};
hotfixDisabledMessage: { [key: string]: string } = {}; 
  // Initialize the releaseTitle and releaseDescription variables
  releaseTitle = '';
  releaseDescription = '';
  // Declare the columnDefs variable
  columnDefs: any;
  // Declare the agGridColDef variable
  agGridColDef: any;
  // Set the initial page size for pagination
  pageSize = 30;
  infiniteInitialRowCount = 30;

  // Define the available page size options for pagination
  pageSizeList: number[] = [30, 50, 100];
  // Set the loading flag to false
  loading: boolean;
  // Initialize the releaseList array
  releaseList: Array<AddViewRelease> = [];
  // Define the row model type
  // Set the row height for the grid
  rowHeight = 45;
  // Set the style for the chip div
  styleChipDiv = 'height: calc(100vh - 160px); flex: 1 1 auto;';
  // Declare the agGridRowData variable
  agGridRowData: any;
  testWidth = 250;
  isMenuShow= true;
  gridOptions: GridOptions;
  public columnToolPanel : IColumnToolPanel;
    rowModelType: RowModelType = 'serverSide'; // ag grid row model type
    cacheBlockSize: any = 30;
  maxBlocksInCache: any = 30;
  serverSideStoreType = 'partial';
  //Represents the default column definition for the add-view-release-list component.
  public defaultColDef: ColDef = {
    //Specifies whether the column is sortable.
    sortable: true,
    //Specifies whether the column is resizable.
    resizable: true,
    //Specifies whether the column has a filter.
    filter: true,
    //Specifies whether the column can be used for row grouping.
    enableRowGroup: true,
    //Specifies whether the column can be used for value aggregation.
    enableValue: true,
    //Specifies whether the column is editable.
    editable: false,
    //Specifies whether the column height is automatically adjusted based on the content.
    autoHeight: true
  };
  /**
   * Represents the side bar configuration for the add-view-release-list component.
   * It can be of type SideBarDef, string, boolean, or null.
   */
  public sideBar: SideBarDef | string | boolean | null = {
    //An array of tool panels to be displayed in the side bar.
    toolPanels: [
      {
        //The unique identifier for the columns tool panel.
        id: 'columns',
        //The default label for the columns tool panel.
        labelDefault: 'Columns',
        //The label key for the columns tool panel.
        labelKey: 'columns',
        //The icon key for the columns tool panel.
        iconKey: 'columns',
        //The tool panel component to be used for the columns tool panel.
        toolPanel: 'agColumnsToolPanel',
      },
      {
        //The unique identifier for the filters tool panel.
        id: 'filters',
        //The default label for the filters tool panel.
        labelDefault: 'Filters',
        //The label key for the filters tool panel.
        labelKey: 'filters',
        //The icon key for the filters tool panel.
        iconKey: 'filter',
        //The tool panel component to be used for the filters tool panel.
        toolPanel: 'agFiltersToolPanel',
      }
    ]
  };

  // `gridDataParams` is used to store grid parameters
  gridDataParams: any;
  // `api` is used to interact with the grid
  api: any;
  // `cacheBlockSize` is the number of rows fetched per block from the server
  // `maxBlocksInCache` is the maximum number of blocks allowed in the cache
  // `blockLoadDebounceMillis` is the debounce time in milliseconds for block loading
  blockLoadDebounceMillis = 100;
  // `frameworkComponents` is an object that maps component names to component classes
  frameworkComponents: any = {
    progressRender: ReleaseProgressComponent,
    agLinkRenderer: AgLinkRendererComponent
  };
  // `gridColumnApi` is used to interact with the grid's columns
  public gridColumnApi: any;
  // `overlayNoRowsTemplate` is the HTML that is displayed when the grid has no rows
  public overlayNoRowsTemplate = '<span style="font-weight: 400; color: #757575; ">No records found</span>';

  // flag to check if there is any active release in progress
  isReleaseInProgress : boolean;

  // Constructor function that injects various services for use in the component
  constructor(public readonly agGridConfigurationService: AgGridConfigurationService, // Service for configuring the ag-Grid
    private readonly constantsService: ConstantsService, // Service for accessing application constants
    public contextMenu: MenuContextualService, // Service for managing the context menu
    public viewContainerRef: ViewContainerRef, // Reference to the component's view container
    private readonly addViewReleaseListService: AddViewReleaseListService, // Service for managing the add/view release list
    private readonly router: Router, // Angular's Router service for navigation
    public loaderService: LoaderService, // Service for managing the loading spinner
    public alertService: AlertService, // Service for managing alerts
    private readonly toastr: ToastrService, // Service for displaying toast messages
    private readonly serviceConstant: ConstantsService, // Service for accessing application constants
    public readonly userAuthService: UserAuthService, // Inject UserAuthService
    public loader: LoaderService,
     public releaseMgmtService: ReleaseMgmtService,
  ) { }

  // `ngOnInit` is a lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
  ngOnInit(): void {

    // After grid is initialized, auto-size columns to fit the grid width
    setTimeout(() => {
      if (this.api) {
      this.api.sizeColumnsToFit();
      }
    }, 0);

    // `agGridColDef` is an object that defines the structure and properties of the columns in the ag-Grid table
    this.agGridColDef = {
      tableName: 'tableName',
      column: [
      { columnName: 'ReleaseName', pinned: true, headerName: 'Release Name', dataType: 'string', columnType: 'string', sortable: true, minWidth: 162, maxWidth: 162, editable: false },
        { columnName: 'ReleaseType', pinned: true, headerName: 'Release Type', dataType: 'string', columnType: 'string', sortable: true, minWidth: 162, maxWidth: 162, editable: false },
      { columnName: 'CreatedBy', headerName: 'Created By', dataType: 'string', columnType: 'string', sortable: true, width: 15, minWidth: this.columnWidth('triggerReleaseGrid', 15), maxWidth: this.columnWidth('triggerReleaseGrid', 54), editable: false },
      { columnName: 'CreatedDateTime', headerName: 'Created Date', dataType: 'date', columnType: 'date', sortable: true, width: 15, minWidth: this.columnWidth('triggerReleaseGrid', 15), maxWidth: this.columnWidth('triggerReleaseGrid', 54), editable: false ,filter: 'agDateColumnFilter'},
      { columnName: 'RepoCreationStatus', headerName: 'Release Activity Status', dataType: 'string', columnType: 'string', width: 250, minWidth: 250, maxWidth: 250, editable: false },
      { columnName: 'DeploymentStatus', headerName: 'Release Deployment Status', dataType: 'string', columnType: 'string', sortable: true, width: 15, minWidth: this.columnWidth('triggerReleaseGrid', 15), maxWidth: this.columnWidth('triggerReleaseGrid', 54), editable: false },
      { columnName: 'LastUpdatedBy', headerName: 'Updated By', dataType: 'string', columnType: 'string', sortable: true, width: 15, minWidth: this.columnWidth('triggerReleaseGrid', 15), maxWidth: this.columnWidth('triggerReleaseGrid', 54), editable: false },
      { columnName: 'LastUpdatedDateTime', headerName: 'Updated Date', dataType: 'date', columnType: 'date', sortable: true, width: 15, minWidth: this.columnWidth('triggerReleaseGrid', 15), maxWidth: this.columnWidth('triggerReleaseGrid', 54), editable: false  ,filter: 'agDateColumnFilter'},
      { columnName: 'ACTION', headerName: 'Action', dataType: 'string', columnType: 'string', filter: false, cellStyle: { textAlign: 'left' }, width: 40, minWidth: this.columnWidth('triggerReleaseGrid', 4), maxWidth: this.columnWidth('triggerReleaseGrid', 8), headerClass: 'ag-header-left-align', editable: false }
      ]
    };
    // Added grid options
    this.gridOptions = {
      // onBodyScroll
      onBodyScroll: this.handleScroll.bind(this),
      // onCellClicked
      onCellClicked: this.handleCellClick.bind(this)
      // other grid options here
    };

    // `rowModelType` is set to 'serverSide' to enable server-side row model in ag-Grid
    this.rowModelType = 'serverSide';
    // Set columnDefs initially so grid loads on first render
    this.columnDefs = this.agGridConfigurationService.getReleaseDetails(this.agGridColDef);
    // Subscribe to permission changes and update columnDefs if permissions change
    this.userAuthService.permissionUpdated.subscribe(() => {
      this.columnDefs = this.agGridConfigurationService.getReleaseDetails(this.agGridColDef);
    });
    // `releaseTitle` and `releaseDescription` are set to the corresponding properties from `constantsService`
    this.releaseTitle = this.constantsService.releaseTitle;
    this.releaseDescription = this.constantsService.releaseDescription;
   window.addEventListener('releaseNameClicked', (event: CustomEvent) => {
    this.handleReleaseNameClick(event.detail);
  });
  }
  ngOnDestroy(): void {
  // Clean up the event listener
  window.removeEventListener('releaseNameClicked', this.handleReleaseNameClick);
  }
  handleReleaseNameClick(releaseData: any): void {

    if (releaseData?.data?.ReleaseType === 'Hotfix' || releaseData?.data?.ReleaseType === 'Patch') {
      this.router.navigate([`/release/modify-hotfix/${releaseData?.data?.Id}`]);
    }
    else {
      this.router.navigate([`/release/modify-release/${releaseData?.data?.Id}`]);
    }
  }
  // This method is triggered when the body of the grid is scrolled
  handleScroll(event) {
    // If the context menu is currently shown
    if (this.isMenuShow) {
      // Hide the context menu
      this.isMenuShow = false;
    }
  }
  columnWidth(id, percentage) {
    const div = document.getElementById(id);  // HTML ID of Grid
      const parent = div.parentElement;
      const width = parent.clientWidth * percentage / 100;  // Pixel calculation
      return width;
  }
  // This method is triggered when a cell in the grid is clicked
  handleCellClick(event) {
    // If the clicked cell is in the 'ACTION' column
    if (event.column.colId === 'ACTION') {
      // Handle the click event for the 'ACTION' column here
      // For example, you might want to show the context menu
      this.isMenuShow = true;
    }
    // Make the 'DeploymentStatus' column clickable and navigate to details page
    else if (event.column.colId === 'DeploymentStatus' && this.userAuthService.checkPermission('MANAGE.RELEASE.DEPLOYMENT.STATUS.VIEW')) {
      if (event.data && event.data.Id) {
        this.router.navigate([`/release/release-deployment-dtls/${event.data.Id}`]);
      }
    }
  }


  /**
   * Sets the loader state to indicate that a loading process has started.
   * Also displays the loading spinner.
   */
  setLoader() {
    // `loading` is set to true to indicate that a loading process has started
    this.loading = true;
    // `showSpinner.next(true)` is called on `loaderService` to display the loading spinner
    this.loaderService.showSpinner.next(true);
  }

  /**
   * Sets the loader state to indicate that the loading process has ended.
   * Hides the loading spinner.
   */
  setUnLoader() {
    // `loading` is set to false to indicate that the loading process has ended
    this.loading = false;
    // `showSpinner.next(false)` is called on `loaderService` to hide the loading spinner
    this.loaderService.showSpinner.next(false);
  }


  /**
   * Navigates to the '/release/create-release' route using Angular's Router service.
   */
  addNewRelease() {
    // This line navigates to the '/release/create-release' route using Angular's Router service
    this.router.navigate(['/release/create-release']);
  }



  /**
   * Callback function triggered when the ag-Grid is ready.
   * @param params - The parameters passed to the function.
   */
  onGridReady = (params) => {
    // `gridDataParams` is set to the parameters passed to the method
    this.gridDataParams = params;
    // `api` is set to the api property of the parameters, which is the ag-Grid API
    this.api = params.api;
    // `gridColumnApi` is set to the columnApi property of the parameters, which is the ag-Grid Column API
    this.gridColumnApi = params.api;
    // `columnToolPanel` is set to the tool panel instance for columns, cast to the IColumnToolPanel interface
    this.columnToolPanel = (this.api.getToolPanelInstance('columns')) as IColumnToolPanel;
    // The visibility of various sections in the column tool panel is set to false
    this.columnToolPanel.setPivotModeSectionVisible(false);
    this.columnToolPanel.setRowGroupsSectionVisible(false);
    this.columnToolPanel.setValuesSectionVisible(false);
    this.columnToolPanel.setPivotSectionVisible(false);
    // The page size for pagination in the ag-Grid is set to `pageSize`
    this.api.paginationSetPageSize(this.pageSize)
    // `datasource` is set to the result of the `getGridData` method with null as the argument
    const datasource = this.getGridData(null);
    // The server-side datasource for the ag-Grid is set to `datasource`
    this.api.setServerSideDatasource(datasource);
    this.api.setSideBar(false);

  }

  // `@HostListener` decorator is used to declare a DOM event to listen for, and provide a handler method to run when that event occurs
  @HostListener('window:resize', ['$event'])


  /**
   * Event handler for window resize event.
   * Adjusts the height of the element with id 'myGrid' and calls the `sizeColumnsToFit` method of the ag-Grid API to adjust column widths.
   */
  onResize() {
    // `h` is set to the inner height of the window minus 210 pixels, converted to a string with 'px' appended
    const h = window.innerHeight - 210 + 'px';
    // The height of the element with the id 'myGrid' is set to `h`
    document.querySelector<HTMLElement>('#triggerReleaseGrid')!.style.height = h;
    // After a delay of 0 milliseconds, the `sizeColumnsToFit` method of the ag-Grid API is called to adjust the column widths to fit the grid's width
    setTimeout(() => {
      this.api.sizeColumnsToFit();
    }, 0);
  }



  /**
   * Retrieves the grid data for lazy loading.
   * @param event The lazy load event containing the request parameters.
   * @returns An object with a `getRows` method that sets the column definitions for the ag-Grid,
   * makes a request to get the release details list, and sets the row data for the ag-Grid.
   */
  /* istanbul ignore next */  
  getGridData(event: TableLazyLoadEvent) {
    return {
      // `getRows` is a method that sets the column definitions for the ag-Grid, makes a request to get the release details list, and sets the row data for the ag-Grid
      getRows: (params) => {

        // The column definitions for the ag-Grid are set to `columnDefs`
        this.api.setColumnDefs(this.columnDefs);
        // `inputRequest` is an object with a `requestParameters` property that is set to the stringified request parameters
        const inputRequest = {
          requestParameters: JSON.stringify(params.request)
        };
        this.loader.showSpinner.next(true);

        // A request is made to get the release details list with `inputRequest` as the argument
        this.addViewReleaseListService.releasedetailslist(inputRequest).subscribe({ next: (res) => {
          // If a response is received
          if (res?.data) {
            // `releaseList` is set to the data from the response, mapped to an array of objects with properties for each column in the ag-Grid
            this.releaseList = res.data.map(x => {
              // This code is returning an object with properties mapped from the `x` object. 
              // Each property of the returned object corresponds to a property of the `x` object.
              return {
                ReleaseName: x.ReleaseName,
                ReleaseType: x.ReleaseType,
                CreatedBy: x.CreatedBy,
                CreatedDateTime: x.CreatedDateTime,
                RepoCreationStatus: x.RepoCreationStatus,
                PipelineCreationStatus: x.PipelineCreationStatus,
                DeploymentStatus: x.DeploymentStatus,
                DeploymentStatusUrl: x.DeploymentStatusUrl,
                SyncDBStatus: x.SyncDBStatus,
                LastUpdatedBy: x.LastUpdatedBy,
                LastUpdatedDateTime: x.LastUpdatedDateTime,
                Id: x.Id,
                IsBranchCreationUpdateCall: x.IsBranchCreationUpdateCall,
                IsReleaseManifestsUpdateCall: x.IsReleaseManifestsUpdateCall,
                ParentReleaseName: x.ParentReleaseName
              }
            })
            // `agGridRowData` is set to `releaseList`
            this.agGridRowData = this.releaseList;

            //set flag for active release progress
            this.isReleaseInProgress = res.isReleaseInProgress
            // The `success` method of the parameters is called with an object that has `rowData` set to `agGridRowData` and `rowCount` set to the total count from the response
            params.success({
              rowData: this.agGridRowData,
              rowCount: res.totalCount,
            });
            this.loader.showSpinner.next(false);
          }
          else
          {
            params.success({
              rowData: this.agGridRowData,
              rowCount: 0,
            });
            this.loader.showSpinner.next(false);
          }
        },
          // If an error occurs, it is logged to the console
         error: (error) => { console.log(error);this.loader.showSpinner.next(false); }});
      }
    }
  }



  /**
   * Refreshes the data in the ag-Grid by setting the server-side datasource.
   */
   /* istanbul ignore next */  
  refreshData() {
  this.hotfixDisabledStatus = {};
  this.hotfixDisabledMessage = {};
  this.setLoader();
  this.api.refreshServerSide();
  this.api.addEventListener('modelUpdated', () => {
    this.setUnLoader();
  });
}


  /**
   * Handles the click event on the table menu.
   * If the column id of the clicked cell is "ACTION", it sets the selectedRow to the data of the clicked row
   * and opens the context menu with the event, view container ref, row data, selected row, origin, and menu template as arguments.
   * 
   * @param event - The click event object.
   * @param origin - The origin of the click event.
   * @param menuTemplate - The template for the context menu.
   */
  tableMenuClick(event, origin: any, menuTemplate) {
    // If the column id of the clicked cell is "ACTION"
    if (event.column.colId === 'ACTION') {
      
      if (this.userAuthService.checkPermission('MANAGE.RELEASE.ADD')) {
        const releaseId = event.data?.Id;
        
        if (releaseId) {
          this.CheckIsBranchCreationCompleted(event.data, (hasInvalidStatus: boolean) => {
            this.hotfixDisabledStatus[releaseId] = hasInvalidStatus;
          });
        }
      }
      this.contextMenu.open(event.event, this.viewContainerRef, event.data, origin, menuTemplate);
    }
  }

    createBranch(action: any) {
    if (action?.IsBranchCreationUpdateCall ) {
      this.updateStatusAction('UPDATERELEASEBRANCH', action);
    }
    else {
      this.updateStatusAction('CREATERELEASEBRANCH', action);
    }
  }
  /**
   * Updates the status action.
   * @param action - The action to be performed.
   */
  updateStatusAction(action: string, row: any) {
    let apiEndpoint = '';
    const releaseId = row.Id || 0;
    if(action == 'CREATERELEASEBRANCH'){
      apiEndpoint = `release-branch-creation/branch-creation/${releaseId}`;
      let popupTitle, popUpText;
      if(row?.IsBranchCreationUpdateCall) {
        popUpText = 'Are you sure you want to update release branch?';
        popupTitle = 'Update Release Branch';
      }
      else {
        popUpText = 'Are you sure you want to create release branch?';
        popupTitle = 'Create Release Branch';
      }
      this.callReleaseApi(apiEndpoint, popupTitle, popUpText, 'Release branch created successfully', 'Failed to create release branch')
    }
    else if(action == 'UPDATERELEASEBRANCH'){
      apiEndpoint = `release-branch-creation/modify-branch-status/`;
      let popupTitle, popUpText;
      if(row?.IsBranchCreationUpdateCall) {
        popUpText = 'Are you sure you want to update release branch?';
        popupTitle = 'Update Release Branch';
        row.RepoCreationStatus = 'Success';
      }
      else {
        popUpText = 'Are you sure you want to create release branch?';
        popupTitle = 'Create Release Branch';
        row.RepoCreationStatus = 'InProgress';

      }
      this.callReleaseApi(apiEndpoint, popupTitle, popUpText, 'Release branch updated successfully', 'Failed to update release branch', row,
      // Add a callback for error to set status as 'Failed'
      (error) => { row.RepoCreationStatus = 'Failed'; }
      );
    }
    else if(action == 'CREATERELEASEPIPELINE') {
      let popupTitle, popUpText;
      if(row?.IsReleaseManifestsUpdateCall){
        popUpText = 'Are you sure you want to update release manifest?';
        popupTitle = 'Update Release Manifest';
      }
      else {
        popUpText = 'Are you sure you want to create release manifest?';
        popupTitle = 'Create Release Manifest';
      }
      apiEndpoint = `release-pipeline-creation/create-release-pipeline/${releaseId}`
      this.callReleaseApi(apiEndpoint, popupTitle, popUpText, 'Release manifest created successfully', 'Failed to create release manifest')
    }
    else if(action == 'VIEWSTATUS'){
      if(releaseId != 0){
      const routePrefix='/release/release-deployment-dtls/'+releaseId;
      this.router.navigate([routePrefix]);
        }else{
          this.toastr.error('Deployment status url not found', 'error');
        }
    }
    else if(action == 'SYNCDB'){
      let popupTitle, popUpText;
      popUpText = 'Are you sure you want to Sync DB?';
      popupTitle = 'Sync Database';
      apiEndpoint = `sync-dB/trigger-sync-db/${releaseId}`
      this.callReleaseApi(apiEndpoint, popupTitle, popUpText, 'The process for syncing the staging DB with production DB is in progress', 'Failed to sync databse')
    }
  }

  callReleaseApi(apiEndpoint: string, popUpTitle: string, popUpText: string, successMessage: string, errorMessage: string, payload?: any, onError?: (error: any) => void) {
    this.alertService.buildDialog().fire({
      title: popUpTitle,
      text: popUpText,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      icon: this.alertService.QuestionIcon
    }).then((result) => {
      if (result.value) {
        this.loaderService.showSpinner.next(true);
        this.addViewReleaseListService.callReleaseApi(apiEndpoint, payload).subscribe({ next: (res) => { 
          if (res) {
            this.loaderService.showSpinner.next(false);
            this.toastr.success(successMessage, 'Success');
            this.refreshData();               
          }
          else{  this.loaderService.showSpinner.next(false);   this.toastr.error(errorMessage, 'error');  }
        },
        // If an error occurs, it is logged to the console
       error: (error) => { this.loaderService.showSpinner.next(false);  this.toastr.error(error?.error?.error?.message, 'error');  }});
      }
    });
  }


  /**
   * Modifies a release based on the provided row data.
   * If the `Id` property of `row` exists, the application navigates to the '/release/modify-release/:id' route,
   * where ':id' is the `Id` of `row`.
   * 
   * @param row The row data representing the release to be modified.
   */
  modifyRelease(row: any) {
    // If the `Id` property of `row` exists
    if (row?.Id) {
      // The application navigates to the '/release/modify-release/:id' route, where ':id' is the `Id` of `row`
      this.router.navigate([`/release/modify-release/${row?.Id}`]);
    }
  }

  /**
   * Triggers the release deployment for a given row.
   * 
   * @param row - The row object containing the release information.
   */
  triggerReleaseDeployment(row: any) {

    // Only allow trigger deployment if no active release is in progress
    if(!this.isReleaseInProgress){
   
    // Check if the "row" object has a property named "Id" and if it is truthy (not null or undefined)
      if (row?.Id) {
        // If the condition is true, navigate to a specific route using the Angular router.
        // The route is constructed using template literals and the value of "row.Id" is appended to the route path.
        this.router.navigate([`/release/trigger-release/${row?.Id}`]);
      }

    }
    else{
      this.toastr.error(
        'Kindly wait for the existing deployment to complete, before triggering new deployment.',
        'Error',
        { toastClass: 'ngx-toastr toast-custom-large' }
      );
    }
    

  }
  triggerHotfixDeployment(row: any) {
    // Check if the "row" object has a property named "Id" and if it is truthy (not null or undefined)
    if (row?.Id) {
      // If the condition is true, navigate to a specific route using the Angular router.
      // The route is constructed using template literals and the value of "row.Id" is appended to the route path.
      this.router.navigate([`/release/create-hotfix/${row?.Id}`]);
    }
  }
  /**
   * Triggers the rollback migration for a given row.
   * 
   * @param row - The row object containing the release information
  **/
  triggerRollbackMigration(row: any) {

    // Only allow trigger deployment if no active release is in progress
    if(!this.isReleaseInProgress){
   
    // Check if the "row" object has a property named "Id" and if it is truthy (not null or undefined)
      if (row?.Id) {
        // If the condition is true, navigate to a specific route using the Angular router.
        // The route is constructed using template literals and the value of "row.Id" is appended to the route path.
        this.router.navigate([`/release/rollback-list/${row?.Id}`]);
      }

    }
    else{
      this.toastr.error(
        'Kindly wait for the existing deployment to complete, before triggering rollback of database.',
        'Error',
        { toastClass: 'ngx-toastr toast-custom-large' }
      );
    }
    
  }
  /**
   * A no-operation function that does nothing.
   * This function can be used as a placeholder or default event handler.
   */
 noop() { } // no-operation empty event



  getHotfixTooltipMessage(actionId: string): string {
    return 'Complete branch creation in existing ' + this.hotfixDisabledMessage[actionId] + ' to create new hotfix/patch release';
  }
  CheckIsBranchCreationCompleted(action, callback: (isCompleted: boolean) => void) {
    const id = action?.Id;
    if (id) {
      this.releaseMgmtService.apiValidatePipelineCreationStatusVisibility(id).subscribe({
        next: (res) => {
          
          if (res && typeof res === 'string' && res.trim().length > 0) {
            // Store the API response message
            this.hotfixDisabledMessage[id] = res;
            callback(true);
            return;
          }
          // Clear message if no valid response
          this.hotfixDisabledMessage[id] = '';
          callback(res);
        },
        error: (error) => {
          this.hotfixDisabledMessage[id] = '';
          callback(false);
        }
      });
    } else {
      callback(false);
    }
  }
  }
